module.exports = __webpack_public_path__ + "img/img6.2941a963.jpg";